<template>
  <div class="file-manager-demo">
    <el-button @click="selectDirectory">选择文件夹</el-button>
    <el-button @click="loadFileTree" :disabled="!directorySelected">加载文件树</el-button>
    <el-button @click="readFileContent" :disabled="!hasFileTree">读取文件内容</el-button>
    <el-button @click="createNewFile" :disabled="!directorySelected">创建文件</el-button>
    <el-button @click="modifyFile" :disabled="!hasFileTree">修改文件行</el-button>
    <el-button @click="deleteTestFile" :disabled="!hasFileTree">删除文件</el-button>
    <el-button @click="selectFileToUpload">选择文件上传</el-button>

    <el-divider>操作结果</el-divider>
    <pre>{{ resultLog }}</pre>
    <file-manager ref="fileManager"></file-manager>
  </div>
</template>

<script>
import FileManager from './components/FileManager.vue';

export default {
  components: { FileManager },
  data() {
    return {
      directorySelected: false,
      hasFileTree: false,
      fileTree: null,
      resultLog: ''
    };
  },
  methods: {
    // 1. 选择文件夹
    async selectDirectory() {
      try {
        const result = await this.$refs.fileManager.selectDirectory();
        this.directorySelected = true;
        this.log(`已选择文件夹: ${result.name}`);
      } catch (err) {
        this.log(`选择文件夹失败: ${err.message}`);
      }
    },

    // 2. 加载文件树
    async loadFileTree() {
      try {
        const tree = await this.$refs.fileManager.getFileTree();
        this.fileTree = tree;
        this.hasFileTree = true;
        this.log(this.formatFileTree(tree));
        this.log(`文件树加载完成，共${this.countFiles(tree)}个文件`);
      } catch (err) {
        this.log(`加载文件树失败: ${err.message}`);
      }
    },

    // 格式化文件树为树形结构字符串
    formatFileTree(tree, prefix = '', isLast = true) {
      let result = '\n';
      const isArray = Array.isArray(tree);
      const items = isArray ? tree : [tree];

      items.forEach((item, index) => {
        const isLastItem = index === items.length - 1;
        const connector = isLastItem ? '└──' : '├──';
        const newPrefix = prefix + (isLastItem ? '    ' : '│   ');

        // 区分文件夹和文件的图标
        const icon = item.isDirectory ? '📁' : '📄';
        result += `${prefix}${connector} ${icon} ${item.name}\n`;

        // 如果有子文件夹，递归处理
        if (item.isDirectory && item.children && item.children.length > 0) {
          result += this.formatFileTree(item.children, newPrefix, isLastItem);
        }
      });

      return result;
    },

    // 3. 读取文件内容
    async readFileContent() {
      try {
        // 假设文件树中第一个文件存在
        const firstFile = this.findFirstFile(this.fileTree);
        if (!firstFile) {
          this.log('没有找到可读取的文件');
          return;
        }

        const content = await this.$refs.fileManager.getFileContent(firstFile.relativePath);
        // 只显示前100个字符
        const preview = content.length > 100
            ? content.substring(0, 100) + '...'
            : content;

        this.log(`读取文件 ${firstFile.relativePath} 内容: ${preview}`);
      } catch (err) {
        this.log(`读取文件失败: ${err.message}`);
      }
    },

    // 4. 创建新文件
    async createNewFile() {
      try {
        const result = await this.$refs.fileManager.createFile(
            '', // 在根目录
            'test-file.txt',
            '这是测试文件的内容'
        );
        this.log(`创建文件成功: ${result.path}`);
        // 重新加载文件树
        this.loadFileTree();
      } catch (err) {
        this.log(`创建文件失败: ${err.message}`);
      }
    },

    // 5. 修改文件行
    async modifyFile() {
      try {
        const result = await this.$refs.fileManager.modifyFileLines(
            'test-file.txt', // 文件路径
            1, // 开始行
            1, // 结束行
            '这是修改后的内容' // 新内容
        );
        this.log(`修改文件成功: 替换了第${result.startLine}-${result.endLine}行`);
      } catch (err) {
        this.log(`修改文件失败: ${err.message}`);
      }
    },

    // 6. 删除文件
    async deleteTestFile() {
      try {
        const success = await this.$refs.fileManager.deleteFile('test-file.txt');
        if (success) {
          this.log('文件删除成功');
          // 重新加载文件树
          this.loadFileTree();
        }
      } catch (err) {
        this.log(`删除文件失败: ${err.message}`);
      }
    },

    // 7. 选择文件上传
    async selectFileToUpload() {
      try {
        const uploadData = await this.$refs.fileManager.selectFileForUpload(
            '', // 从根目录开始选择
            ['.txt', '.js', '.html'] // 只接受这些类型的文件
        );

        this.log(`选择上传文件: ${uploadData.name} (${uploadData.sizeFormatted})`);

        // 示例：使用fetch上传文件
        // const response = await fetch('/api/upload', {
        //   method: 'POST',
        //   body: uploadData.formData
        // });
        // const result = await response.json();
      } catch (err) {
        this.log(`选择上传文件失败: ${err.message}`);
      }
    },

    // 辅助方法：查找第一个文件
    findFirstFile(tree) {
      for (const item of tree) {
        if (!item.isDirectory) {
          return item;
        }
        if (item.children && item.children.length > 0) {
          const found = this.findFirstFile(item.children);
          if (found) return found;
        }
      }
      return null;
    },

    // 辅助方法：统计文件数量
    countFiles(tree) {
      let count = 0;
      tree.forEach(item => {
        if (item.isDirectory) {
          count += this.countFiles(item.children);
        } else {
          count++;
        }
      });
      return count;
    },

    // 日志记录
    log(message) {
      this.resultLog = `${new Date().toLocaleTimeString()} - ${message}\n${this.resultLog}`;
    }
  }
};
</script>